export default __webpack_public_path__ + "static/media/read-glasses.02b7ec56.svg";